import { UnitDetails } from '@/models/features'

export const formatAddress = (unit?: UnitDetails | null) => {
  if (!unit) return null

  const address = [unit.street, unit.city, [unit.state, unit.zip].filter(Boolean).join(' ')]
    .filter(Boolean)
    .join(', ')

  return address || null
}
